import { assert, error, log } from '../../app/logger.js';
import { AsapPromise } from '../../util/asap_promise.js';

/**
 * Async data array pipe.
 */
const AsyncDataPipeableMixin = PipeableBase =>
  class extends PipeableBase {
    pipe(...args) {
      this.loadIfNeeded(); // async
      return super.pipe(...args);
    }

    get pipeables() {
      this.loadIfNeeded(); // async
      return super.pipeables;
    }

    clear() {
      this.#invalidated = true;
      super.clear();
    }

    async load() {
      if (this.#loading) {
        assert(
          !this.#reloadFlag,
          `[data] AsyncDataPipeableMixin: too many load requests, you might have a bug in logic`
        );
        assert(
          this.#loadingPromise,
          `[data] AsyncDataPipeableMixin: #loadingPromise is null when loading`
        );
        this.#reloadFlag = true;
        return this.#loadingPromise;
      }

      this.#loading = true;
      if (!this.#loadingPromise) {
        this.#loadingPromise = new AsapPromise();
      }

      let sd = Date.now();
      let data = await this.getLoadPromise();
      log(`[data:perf] ${this.dataClassName} data load: ${Date.now() - sd}ms`);

      this.#loading = false;
      if (this.#reloadFlag) {
        this.#reloadFlag = false;
        return this.load();
      }

      this.#loadingPromise.resolve();
      this.#loadingPromise = null;
      this.#invalidated = false;

      let sd2 = Date.now();
      this.set(data);

      log(
        `[data:perf] ${this.dataClassName} data UIing: ${Date.now() - sd2}ms`
      );
      log(
        `[data:perf] ${this.dataClassName} data load + UIing: ${
          Date.now() - sd
        }ms`
      );
    }

    loadIfNeeded() {
      return this.#invalidated && (this.#loadingPromise || this.load());
    }

    invalidate() {
      this.#invalidated = true;
    }

    get dataClassName() {
      error(`[data] AsyncDataPipeableMixin.dataClassName must be overriden`);
      return '';
    }

    getLoadPromise() {
      error(`[data] AsyncDataPipeableMixin.getLoadPromise must be overriden`);
      return Promise.resolve([]);
    }

    #invalidated = true;
    #reloadFlag = false;
    #loading = false;
    #loadingPromise;
  };

export { AsyncDataPipeableMixin };
